/* BamBam House: Kaupauki.
   Setur Glowxie Glass Nail File Duo sjálfkrafa í körfuna þegar 2 vörur eða fleiri eru komnar í hana,
   og tekur það aftur úr körfunni ef vörunum fækkar niður fyrir 2.
   Gildir ekki þegar Haustkarfan (línur með eiginleikanum "Gjafakarfa") er í körfunni.
   Afslátturinn sjálfur (0 kr) kemur úr sjálfvirkum afslætti í Shopify admin, ekki héðan.
   Til að slökkva á: fjarlægja <script> línuna fyrir kaupauki.js úr snippets/cart-drawer.liquid. */
(function () {
  var GIFT_VARIANT_ID = 42402211659831;
  var MIN_ITEMS = 2;
  var PROP = '_kaupauki';
  var BASKET_PROP = 'Gjafakarfa'; // Línueiginleiki sem Haustkarfan setur á sínar vörur

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var timer = null;

  function store(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      if (value === null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  function onCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function render(res) {
    if (onCartPage()) { window.location.reload(); return; }
    var drawer = drawerEl();
    if (!drawer || !res || !res.sections) return;
    var parse = function (html, sel) {
      var doc = new DOMParser().parseFromString(html || '', 'text/html');
      var el = doc.querySelector(sel);
      return el ? el.innerHTML : null;
    };
    var inner = parse(res.sections['cart-drawer'], '#CartDrawer');
    var target = document.querySelector('#CartDrawer');
    if (inner !== null && target) {
      target.innerHTML = inner;
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
      drawer.classList.toggle('is-empty', res.item_count === 0);
      var box = drawer.querySelector('.drawer__inner');
      if (box) box.classList.toggle('is-empty', res.item_count === 0);
    }
    var bubble = parse(res.sections['cart-icon-bubble'], '.shopify-section');
    var bubbleEl = document.getElementById('cart-icon-bubble');
    if (bubble !== null && bubbleEl) bubbleEl.innerHTML = bubble;
  }

  function post(url, body) {
    if (!onCartPage() && drawerEl()) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    return nativeFetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function addGift() {
    var props = {};
    props[PROP] = '1';
    return post('cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: props }] })
      .then(function (res) {
        if (!res || res.status) { store('kaupauki_stop', '1'); return; }
        store('kaupauki_added', '1');
        store('kaupauki_declined', null);
        return nativeFetch(root + 'cart.js', { cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { res.item_count = cart.item_count; render(res); });
      });
  }

  function removeGift(key) {
    return post('cart/change.js', { id: key, quantity: 0 }).then(function (res) {
      store('kaupauki_added', null);
      render(res);
    });
  }

  function check() {
    if (busy || store('kaupauki_stop')) return;
    busy = true;
    nativeFetch(root + 'cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftQty = 0;
        var giftLine = null;
        (cart.items || []).forEach(function (item) {
          if (item.variant_id === GIFT_VARIANT_ID) {
            giftQty += item.quantity;
            if (item.properties && item.properties[PROP]) giftLine = item;
          }
        });
        var others = cart.item_count - giftQty;

        // Haustkarfan: kaupaukinn gildir ekki með henni. Taka sjálfvirku gjöfina út ef hún er komin inn.
        var hasHaustkarfa = (cart.items || []).some(function (item) {
          return item.properties && item.properties[BASKET_PROP];
        });
        if (hasHaustkarfa) {
          store('kaupauki_declined', null);
          if (giftLine) return removeGift(giftLine.key);
          return;
        }

        if (others >= MIN_ITEMS) {
          if (giftQty > 0) return;
          if (store('kaupauki_added')) {
            // Viðskiptavinurinn tók gjöfina sjálf/ur úr körfunni. Ekki setja hana aftur inn.
            store('kaupauki_added', null);
            store('kaupauki_declined', '1');
            return;
          }
          if (store('kaupauki_declined')) return;
          return addGift();
        }

        store('kaupauki_declined', null);
        if (giftLine) return removeGift(giftLine.key);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(check, delay || 500);
  }

  // Fylgjast með þegar þemað breytir körfunni (bæta í körfu, breyta magni, fjarlægja).
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update)/.test(url)) {
      p.then(function () { schedule(600); }, function () {});
    }
    return p;
  };

  // "Bæta við frítt" hnappurinn í "Passar vel með" boxinu.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-kaupauki-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    store('kaupauki_declined', null);
    busy = true;
    addGift().catch(function () { btn.disabled = false; }).then(function () { busy = false; });
  });

  schedule(800);
})();
